import type React from "react";
import { LOOK } from "../../b2c/look";
import type { Stage } from "../stage";

/**
 * The reward's fine print (Offer and End cards), same box in both.
 *
 * Story: it sits just above the Reels/TikTok caption stack (bottom 500px in
 * the cross-platform worst case), so the line that qualifies "jusqu'à" is
 * never the one the platform UI covers. `FOOT_ROOM` is the extra room the
 * scene's centred content leaves under itself for it.
 */
export const FOOT_ROOM: Record<Stage["shape"], number> = {
  tall: 110,
  feed: 40,
  square: 36,
  wide: 0,
};

export const footnoteBox = (stage: Stage): React.CSSProperties => ({
  position: "absolute",
  left: stage.safe.left,
  right: stage.safe.right,
  bottom: stage.shape === "tall" ? 500 : 26,
  textAlign: "center",
  textWrap: "balance",
  fontFamily: LOOK.body,
  fontSize: { tall: 26, feed: 25, square: 24, wide: 24 }[stage.shape],
  lineHeight: 1.3,
  fontWeight: LOOK.medium,
});
